module.exports = __webpack_public_path__ + "static/media/James-wong-Barton-Farm.68a3eaa9.jpg";